// Marka, iletişim ve dış bağlantılar. Kaynak: flyexpress.com (2026-10-02 incelemesi).
// Değişiklik buradan yapılır; bileşenler bu değerleri doğrudan kullanır. Menüler Site Yönetimi → Menüler'den gelir
// (varsayılanlar: src/lib/menus/menu-core.ts).

export const site = {
  name: "FlyExpress",
  legalName: "Fly Express Turizm Ticaret A.Ş.",
  // Mevcut sitenin altbilgisinde yazan acente unvanı ve TÜRSAB belge numarası
  agencyTitle: "Yolculuk Zamanı Turizm Seyahat Acentası",
  tursabNo: "12724",
  // Marka mottosu (2026-10-22, tescil sürecinde); logoyla birlikte: features/site-content/brand.ts
  tagline: "Haritada varsa, fly’da var",
  description:
    "FlyExpress; Avrupa'dan Uzakdoğu'ya, Afrika'dan Amerika'ya paket turlar, kruvaziyer programları ve yurt dışı destinasyon hizmetleri sunan tur operatörüdür. Turlarımız yetkili acentelerimiz aracılığıyla satılır.",
  contact: {
    phone: "0850 888 27 40",
    phoneHref: "tel:+908508882740",
    fax: "0850 888 70 80",
    email: "agencysupport@flyexpress.com",
    address: "19 Mayıs Mh. 19 Mayıs Cad. Nova Baran Plaza No: 4/59 Kat: 11, Şişli / İstanbul",
    mapsHref: "https://www.google.com/maps/search/?api=1&query=Nova+Baran+Plaza+%C5%9Ei%C5%9Fli+%C4%B0stanbul",
  },
  agencyPanelUrl: "https://flex.flyexpress.com/",
  social: [
    { label: "Instagram", href: "https://www.instagram.com/flyexpresstr/" },
    { label: "Facebook", href: "https://www.facebook.com/flyexpresstouroperator" },
    { label: "LinkedIn", href: "https://www.linkedin.com/company/flyexpress" },
  ],
} as const;
